export default "__VITE_ASSET__C1QeN2pd__"